var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyResultsModel } from "survey-creator-core";
import { attachKey2click, SurveyLocStringViewer, SvgIcon } from "survey-react-ui";
import { ActionButton } from "./ActionButton";
import { CreatorModelElement } from "./ModelElement";
var SurveyResults = /** @class */ (function (_super) {
    __extends(SurveyResults, _super);
    function SurveyResults() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyResults.prototype.createModel = function (props) {
        if (this.props.survey) {
            this.model = new SurveyResultsModel(props.survey);
        }
    };
    SurveyResults.prototype.getUpdatedModelProps = function () {
        return ["survey"];
    };
    SurveyResults.prototype.getStateElement = function () {
        return this.model;
    };
    SurveyResults.prototype.render = function () {
        var _this = this;
        if (!this.model) {
            return null;
        }
        return (React.createElement("div", { className: "svd-test-results" },
            React.createElement("div", { className: "svd-test-results__content" },
                React.createElement("div", { className: "svd-test-results__header" },
                    React.createElement("div", { className: "svd-test-results__header-text" }, this.model.surveyResultsText),
                    React.createElement("div", { className: "svd-test-results__header-types" },
                        React.createElement(ActionButton, { click: function () { return _this.model.selectTableClick(); }, text: this.model.surveyResultsTableText, selected: this.model.isTableSelected, disabled: false }),
                        React.createElement(ActionButton, { click: function () { return _this.model.selectJsonClick(); }, text: this.model.surveyResultsJsonText, selected: this.model.isJsonSelected, disabled: false }))),
                this.renderResultAsText(),
                this.renderResultAsTable())));
    };
    SurveyResults.prototype.renderResultAsText = function () {
        if (this.model.resultViewType !== "text") {
            return null;
        }
        return (React.createElement("div", { className: "svd-test-results__text svd-light-bg-color" },
            React.createElement("div", null, this.model.resultText)));
    };
    SurveyResults.prototype.renderResultAsTable = function () {
        if (this.model.resultViewType !== "table") {
            return null;
        }
        return (React.createElement("div", { className: "svd-test-results__table svd-light-bg-color" },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", { className: "svd-light-background-color" },
                        React.createElement("th", { key: 1, className: "svd-dark-border-color" }, this.model.resultsTitle),
                        React.createElement("th", { key: 2, className: "svd-dark-border-color" }, this.model.resultsDisplayValue))),
                React.createElement("tbody", null, SurveyResults.renderRows(this.model.resultData)))));
    };
    SurveyResults.renderRows = function (data) {
        var rows = [];
        for (var i = 0; i < data.length; i++) {
            rows.push(React.createElement(SurveyResultsByRow, { key: i + 1, row: data[i] }));
        }
        return rows;
    };
    return SurveyResults;
}(CreatorModelElement));
export { SurveyResults };
var SurveyResultsByRow = /** @class */ (function (_super) {
    __extends(SurveyResultsByRow, _super);
    function SurveyResultsByRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyResultsByRow.prototype, "row", {
        get: function () {
            return this.props.row;
        },
        enumerable: false,
        configurable: true
    });
    SurveyResultsByRow.prototype.getStateElement = function () {
        return this.row;
    };
    SurveyResultsByRow.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            attachKey2click(React.createElement("tr", { onClick: function () { return _this.row.toggle(); } },
                React.createElement("td", { key: 1, style: { paddingLeft: this.row.textMargin }, className: "svd-dark-border-color" },
                    this.row.isNode ? (React.createElement("span", { style: { left: this.row.markerMargin }, className: "svd-test-results__marker " + (this.row.collapsed ? "" : "svd-test-results__marker--expanded") },
                        React.createElement(SvgIcon, { iconName: "icon-expand_16x16", size: 16 }))) : null,
                    this.row.question ? React.createElement(SurveyLocStringViewer, { locStr: this.row.question.locTitle }) : React.createElement("span", null, this.row.title)),
                React.createElement("td", { key: 2, className: this.row.isNode ? "svd-test-results__node-value" : "svd-dark-border-color" }, this.row.getString(this.row.displayValue)))),
            this.row.isNode && !this.row.collapsed ? SurveyResults.renderRows(this.row.data) : null));
    };
    return SurveyResultsByRow;
}(CreatorModelElement));
export { SurveyResultsByRow };
